export const todayIso = () => new Date().toISOString().slice(0, 10);

export const daysAgoIso = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
};

export const defaultDateRange = () => ({
  fromDate: daysAgoIso(29),
  toDate: todayIso(),
});

export async function fetchHqFranchiseOptions(api) {
  const data = await fetchHqKpisLight(api);
  return Array.isArray(data?.franchises) ? data.franchises : [];
}

async function fetchHqKpisLight(api) {
  const res = await api('/naturals/kpis');
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || 'Failed to load franchises');
  }
  return data;
}
